export enum TranslationKeys {
  SelectLanguage = 'SelectLanguage',
}
